<template>
  <div class="layout__recipe" :class="{ 'is-scrolled': isScrolled, 'has-toolbar': true }">
    <CMToolbar
      :nav="toolbarNavItem">
      <CMButton v-for="(item, index) in toolbarActionItemsGrouped.always" :key="index" v-bind="item"></CMButton>
      <MUIMenu :items="toolbarActionItemsGrouped.never" anchor="right">
        <CMButton icon="more_vert" name="More" slot="button"></CMButton>
      </MUIMenu>
    </CMToolbar>
    <ScrollLayout
      class="layout__recipe--regular"
      :class="{ 'has-image': recipe.hasImage }"
      :onScroll="onScroll"
      ref="scrollpane">
      <div class="layout__inner">
        <div class="layout__header">
          <div
            class="recipe__image shadow--1dp"
            :class="{ 'recipe__image--local': recipe.isLocalImage }"
            @click="enlargeImage"
            v-if="recipe.hasImage">
            <progressive-background
              :src="recipe.imageUrl('preview')"
              :placeholder="recipe.imageUrl('placeholder')"
              :aspect-ratio="0.75" />
          </div>
          <div class="layout__header-title">
            {{recipe.parentedTitle || recipe.presentationUrl}}
          </div>

          <RecipeMeta v-bind="recipe.metadata"></RecipeMeta>
          <div class="recipe__collections" v-if="collections">
            <MUIChip
              v-for="item in collections"
              :key="item.key"
              @click.native="transitionToCollection(item.key, recipe.key)"
            >{{item.name}}</MUIChip>
          </div>
        </div>
        <div class="layout__main">
          <Notice :data="notices.missingSchema" v-if="recipe.notFound"></Notice>
          <Ingredients :items="recipe.ingredients" :scale="scale" />
          <Instructions :items="recipe.instructions" />
          <section class="recipe__notes" v-if="recipe.notes">
            <h3>Notes</h3>
            <p v-for="(p, index) in recipe.notes" :key="index">{{p}}</p>
          </section>
        </div>
      </div>
    </ScrollLayout>
  </div>
</template>

<script>
import { ScrollLayout } from '../layouts'

import RecipeMeta from '@/components/RecipeMeta'
import {
  Ingredients,
  Instructions } from '@/components/Recipe'
import MUIChip from '@/components/MUIChip'
import MUIMenu from '@/components/MUIMenu'
import MUITabBar from '@/components/MUITabBar'
import Notice from '@/components/Notice'
import CMToolbar from '@/components/CMToolbar'
import CMButton from '@/components/CMButton'

import {
  // REGISTER_SHORTCUT,
  // DEREGISTER_SHORTCUT,
  SET_DRAWER_VISIBILITY } from '../modules/mutation-types'

export default {
  name: 'recipe-detail-regular',
  components: {
    CMButton,
    CMToolbar,
    Notice,
    Ingredients,
    Instructions,
    RecipeMeta,
    MUIChip,
    MUIMenu,
    MUITabBar,
    ScrollLayout
  },
  computed: {
    toolbarNavItem () {
      let primaryHidden = this.displayMode === 'primaryHidden'
      return {
        id: 'view-as-fullscreen',
        class: { active: primaryHidden },
        fn: this.toggleDrawer,
        icon: primaryHidden ? 'unfold_less' : 'unfold_more',
        showAsAction: 'always',
        name: 'View as fullscreen'
      }
    }
  },
  data () {
    return {
      isScrolled: false,
      // TODO: These can probably be removed
      width: document.documentElement.clientWidth || window.innerWidth || 0,
      height: document.documentElement.clientHeight || window.innerHeight || 0
    }
  },
  props: {
    collections: {
      type: Array,
      default: () => []
    },
    displayMode: {
      type: String,
      default: null
    },
    showPrimaryHandler: {
      type: Function,
      default: () => null
    },
    hidePrimaryHandler: {
      type: Function,
      default: () => null
    },
    notices: Object,
    recipe: Object,
    toolbarActionItemsGrouped: Object,
    transitionToCollection: Function,
    enlargeImage: Function,
    onSelectImage: Function,
    scale: String
  },
  methods: {
    onScroll (ev) {
      this.isScrolled = ev.target.scrollTop > 0
    },
    resetScroll () {
      this.$refs.scrollpane.$el.scrollTop = 0
    },
    toggleDrawer () {
      if (this.displayMode === 'primaryHidden') {
        this.showPrimaryHandler()
      } else {
        this.hidePrimaryHandler()
        this.$store.commit(SET_DRAWER_VISIBILITY, { visibility: 'hidden' })
      }
    }
  },
  watch: {
    recipe () {
      this.resetScroll()
    }
  },
  mounted () {
    // this.$store.commit(REGISTER_SHORTCUT, {
    //   name: 'add-to-collection',
    //   keycode: 67,
    //   fn: this.showAddToCollectionDialog,
    //   scope: 'application'
    // })
    // this.$store.commit(REGISTER_SHORTCUT, {
    //   name: 'delete-recipe',
    //   keycode: 68,
    //   fn: this.onDelete,
    //   scope: 'application'
    // })
    // this.$store.commit(REGISTER_SHORTCUT, {
    //   name: 'edit-recipe',
    //   keycode: 69,
    //   fn: this.showEditDialog,
    //   scope: 'application'
    // })
    // this.$store.commit(REGISTER_SHORTCUT, {
    //   name: 'toggle-favorites',
    //   keycode: 83,
    //   fn: this.toggleFavorites,
    //   scope: 'application'
    // })
  },
  beforeDestroy () {
    // this.$store.commit(DEREGISTER_SHORTCUT, 'edit-recipe')
    // this.$store.commit(DEREGISTER_SHORTCUT, 'toggle-favorites')
  }
}
</script>

<style lang="sass">
@import "../styles/variables.scss"
#view-as-fullscreen i
  transform: rotate(-45deg)
.layout__recipe
  margin: 0 auto
  .device__viewport-size--medium &, .device__viewport-size--large &, .device__viewport-size--xlarge &
    max-width: 920px
.layout__recipe .mui-toolbar
  border-bottom: 0
.layout__recipe--regular
  &.has-image
    .recipe-list-item__meta.inline,
    .layout__header-title,
    .description,
    .recipe__collections
      margin-left: 196px
      width: calc(100% - 196px)
    .layout__header
      min-height: 129px
  .layout__inner
    padding: 13px 24px 48px
    .layout__header-title
      font: $headlineFont
    .recipe-list-item__meta.inline
      margin-bottom: 12px
    .layout__main
      position: relative
    .layout__header
      border-bottom: $layoutBorder
      margin-bottom: 32px
      padding-bottom: 32px
      position: relative
    .recipe__image
      height: 129px
      width: 172px
      cursor: pointer
      background: #fcfcfc
      border-radius: 2px
      position: absolute
      top: 8px
      left: 0
      &:hover
        box-shadow: 0 0 6px 0 rgba(0,0,0,0.24)
      &.recipe__header-image__loading
        background: #fafafa
        cursor: default
      .loader
        left: 46px
        top: 36px
      div
        transform: scale(1.0)!important
    .recipe__ingredients
      width: 300px
      position: absolute
      top: 0
      left: 0
    .recipe__instructions, .recipe__notes
      margin-left: 300px
</style>



// WEBPACK FOOTER //
// src/components/RecipeDetailRegular.vue